import { Switch } from "antd";
import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { callAgentList } from "../../agentlist/redux/AgentAction";
import { Modal } from "../../common/Modal1";
import * as actions from "../redux/MemberAction";
import { EditMemberDialog } from "./EditMemberDialog";
import "./memberList.css";

export const MemberList = ({
  selMemberId,
  currentAgentId,
  currentMemberPage,
  isMemberDetailsVisible,
  memberSettingPermission,
  onClose,
  isAgent,
  onSuccessUpdate,
}) => {
  const intl = useIntl();
  const [swalProps, setSwalProps] = useState({});
  const dispatch = useDispatch();
  const dismissBtnRef = useRef();
  const [nickname, setNickname] = useState("");
  const [password, setPassword] = useState("");
  const [viplevel, setViplevel] = useState("");
  const [isEditModalVisible, setEditModalVisible] = useState(false);
  const [editButton, setEditButton] = useState(false);
  const memberState = useSelector(({ member }) => member, shallowEqual);

  useEffect(() => {
    if (selMemberId) {
      const queryParams = {
        action: "memberdetail",
        memberid: selMemberId,
      };
      dispatch(actions.callMemberList(queryParams)).then((resp) => {
        resp = resp.data;
        setViplevel(
          resp.memberVipLevelLists.find(
            (memberVipLevel) => memberVipLevel.selected === "true"
          )?.viplevel
        );
      });
    }
  }, [selMemberId]);

  useEffect(() => {
    if (memberState && memberState.memberLists) {
      setPassword(memberState.memberLists.password);
      setNickname(memberState.memberLists.nickname);
    }
  }, [memberState]);

  const handleSwitchChange = (checked, member) => {
    const updateQueryParams = {
      action: "updatememberstatus",
      memberid: member,
    };
    dispatch(actions.updateMemberStatus(updateQueryParams))
      .then(() => {
        const queryParams = {
          action: "memberdetail",
          memberid: selMemberId,
        };
        dispatch(actions.callMemberList(queryParams));
      })
      .catch((error) => {
        console.error("Error updating Member status:", error);
      });
  };

  const handleNicknameChange = (e) => {
    setNickname(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleClose = () => {
    onClose();
    onSuccessUpdate?.();
    if (!onSuccessUpdate) {
      const queryParams = {
        action: "agentmemberlist",
        selagentid: currentAgentId,
        agentpagenum: "0",
        memberpagenum: currentMemberPage,
      };
      dispatch(callAgentList(queryParams));
    }
  };
  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Modal
        modalId="memberDetailsModal"
        title={intl.formatMessage({ id: "memberDetails" })}
        dismissBtnRef={dismissBtnRef}
        isVisible={isMemberDetailsVisible}
        onClose={handleClose}
      >
        <SweetAlert2
          customClass="custom-swal"
          onResolve={() => {
            setSwalProps({});
          }}
          {...swalProps}
        />
        <EditMemberDialog
          setSwalProps={setSwalProps}
          memberId={selMemberId}
          nickname={nickname}
          password={password}
          viplevel={viplevel}
          isVisible={isEditModalVisible}
          isAgent={isAgent}
          setEditButton={setEditButton}
          onClose={() => setEditModalVisible(false)}
        />

        <div>
          <div
            className="d-flex"
            style={{
              overflowX: "auto",
              margin: "10px auto",
              justifyContent: "center",
              justifyItems: "center",
            }}
          >
            <div className="d-flex flex-column gap-2 col-9">
              <div className="d-flex">
                <div className="text-start pe-1 col-5">
                  {intl.formatMessage({ id: "username" })} :
                </div>
                <div className="text-start">
                  {memberState.memberLists?.username}
                </div>
              </div>
              <div className="d-flex">
                <div className="text-start pe-1 col-5">
                  {intl.formatMessage({ id: "nickname" })} :
                </div>
                {editButton === true ? (
                  <div className=" text-start">
                    <input
                      type="text"
                      style={{
                        borderColor: "rgba(175, 164, 164, 0.4)",
                        borderRadius: "5px",
                      }}
                      placeholder={memberState.memberLists?.nickname}
                      onChange={handleNicknameChange}
                    />
                  </div>
                ) : (
                  <div className="text-start">
                    {memberState.memberLists?.nickname}
                  </div>
                )}
              </div>
              <div className="d-flex">
                <div className="text-start pe-1 col-5">
                  {intl.formatMessage({ id: "password" })} :
                </div>
                {editButton === true ? (
                  <div className="text-start">
                    <input
                      type="text"
                      style={{
                        borderColor: "rgba(175, 164, 164, 0.4)",
                        borderRadius: "5px",
                      }}
                      placeholder={memberState.memberLists?.password}
                      onChange={handlePasswordChange}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(
                          /[^a-zA-Z0-9]/g,
                          ""
                        );
                      }}
                    />
                  </div>
                ) : (
                  <div className="text-start">
                    {memberState.memberLists?.password}
                  </div>
                )}
              </div>
              <div className="d-flex">
                <div className="text-start pe-1 col-5">
                  {intl.formatMessage({ id: "ipaddress" })} :
                </div>
                <div className="text-start">
                  {memberState.memberLists?.ipaddress === ""
                    ? "-"
                    : memberState.memberLists?.ipaddress}
                </div>
              </div>
              <div className="d-flex">
                <div className="text-start pe-1 col-5">
                  {intl.formatMessage({ id: "inviteby" })} :
                </div>
                <div className="text-start">
                  {memberState.memberLists?.inviteby !== ""
                    ? memberState.memberLists?.inviteby
                    : "-"}
                </div>
              </div>
              <div className="d-flex">
                <div className="text-start pe-1 col-5">
                  {intl.formatMessage({ id: "status" })} :
                </div>
                {memberSettingPermission === "true" ? (
                  <div className="text-start">
                    <Switch
                      checked={memberState.memberLists?.status === "active"}
                      onChange={(checked) =>
                        handleSwitchChange(
                          checked,
                          memberState.memberLists?.memberid
                        )
                      }
                    />
                  </div>
                ) : (
                  <div className="text-start">
                    {memberState.memberLists?.status}
                  </div>
                )}
              </div>
              <div className="d-flex">
                <div className="text-start pe-1 col-5">
                  {intl.formatMessage({ id: "regdate" })} :
                </div>
                <div className="text-start">
                  {memberState.memberLists?.regdate}
                </div>
              </div>
              <div className="d-flex">
                <div className="text-start pe-1 col-5">
                  {intl.formatMessage({ id: "inviteByVip" })} :
                </div>
                <div className="text-start">
                  {memberState.memberLists?.invitebyvipusername !== ""
                    ? memberState.memberLists?.invitebyvipusername
                    : "-"}
                </div>
              </div>
              <div className="d-flex">
                <div className="text-start pe-1 col-5">
                  {intl.formatMessage({ id: "vipLevel" })} :
                </div>
                {editButton === true ? (
                  <div className="text-start">
                    <select
                      type="text"
                      style={{
                        borderColor: "rgba(175, 164, 164, 0.4)",
                        borderRadius: "5px",
                      }}
                      onChange={(e) => setViplevel(e.target.value)}
                      value={viplevel}
                    >
                      {memberState.memberLists?.memberVipLevelLists.map(
                        (memberVipLevel) => (
                          <option
                            value={memberVipLevel.viplevel}
                            key={memberVipLevel.viplevel}
                          >
                            {memberVipLevel.viplevel}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                ) : (
                  <div className="text-start">
                    {
                      memberState.memberLists?.memberVipLevelLists.find(
                        (memberVipLevel) => memberVipLevel.selected === "true"
                      )?.viplevel
                    }
                  </div>
                )}
              </div>
            </div>
          </div>
          {memberSettingPermission === "true" &&
            (editButton === true ? (
              <div className="p-3 d-flex justify-content-evenly">
                <button
                  className="btn btn-success px-3"
                  onClick={() => {
                    setEditModalVisible(true);
                  }}
                >
                  {intl.formatMessage({ id: "submit" })}
                </button>
                <button
                  className="btn btn-danger px-3"
                  onClick={() => {
                    setEditButton(false);
                  }}
                >
                  {intl.formatMessage({ id: "cancel" })}
                </button>
              </div>
            ) : (
              <div className="editButton p-3">
                <button
                  className="btn btn-primary px-3"
                  onClick={() => {
                    setEditButton(true);
                  }}
                >
                  {intl.formatMessage({ id: "edit" })}
                </button>
              </div>
            ))}
        </div>
      </Modal>
    </div>
  );
};
